import React from 'react';
import { makeIcon } from '../../../utils/makeIcon';

export const breakfastIcon = makeIcon(
    <>
        <circle cx="12" cy="12" r="5" />
        <line x1="12" y1="1" x2="12" y2="4" />
        <line x1="12" y1="20" x2="12" y2="23" />
        <line x1="4.2" y1="4.2" x2="6.3" y2="6.3" />
        <line x1="17.7" y1="17.7" x2="19.8" y2="19.8" />
        <line x1="1" y1="12" x2="4" y2="12" />
        <line x1="20" y1="12" x2="23" y2="12" />
        <line x1="4.2" y1="19.8" x2="6.3" y2="17.7" />
        <line x1="17.7" y1="6.3" x2="19.8" y2="4.2" />
    </>,
);

export const brunchIcon = makeIcon(
    <>
        <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z" />
        <path d="M9 21V12h6v9" />
    </>,
);

export const lunchIcon = makeIcon(
    <>
        <path d="M3 2v7c0 1.1.9 2 2 2h1a2 2 0 002-2V2" />
        <line x1="5.5" y1="11" x2="5.5" y2="22" />
        <path d="M19 2a4 4 0 00-4 4v5h4z" />
        <line x1="19" y1="11" x2="19" y2="22" />
    </>,
);

export const snackIcon = makeIcon(
    <>
        <path d="M18 8h1a4 4 0 010 8h-1" />
        <path d="M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z" />
    </>,
);

export const dinnerIcon = makeIcon(
    <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
    </>,
);

export const allDayIcon = makeIcon(
    <>
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
    </>,
);

export const utensilsIcon = makeIcon(
    <>
        <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 002-2V2" />
        <line x1="7" y1="2" x2="7" y2="22" />
        <path d="M21 15V2v0a5 5 0 00-5 5v6c0 1.1.9 2 2 2h3zm0 0v7" />
    </>,
);

export const calendarIcon = makeIcon(
    <>
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
    </>,
);

export const searchIcon = makeIcon(
    <>
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </>,
);

export const closeIcon = makeIcon(
    <>
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
    </>,
);

export const mealFilterIcon = makeIcon(
    <>
        <path d="M3 2v7c0 1.1.9 2 2 2h2a2 2 0 002-2V2" />
        <line x1="5" y1="11" x2="5" y2="22" />
        <path d="M17 2v20" />
        <path d="M13 8c0-3.3 1.8-6 4-6s4 2.7 4 6-1.8 6-4 6" />
    </>,
);

export const restaurantIcon = makeIcon(
    <>
        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
    </>,
);

export const plusIcon = makeIcon(
    <>
        <line x1="12" y1="5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="19" y2="12" />
    </>,
);

export const dishPhotoIcon = makeIcon(
    <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 3v9m0 0l-3-3m3 3l3-3" />
    </>,
);
